<script>
import DataProvider from './DataProvider.vue';
import DepartmentRepository from '../../js/repository/DepartmentRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: DepartmentRepository.findAll,
                params: [this.clubId],
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
